<div class="splash-screen" [@splashFadeOut]="show">
  <img [attr.src]="logoUrl" alt="Logo" />
  <div class="loading-container">
    <div class="loading-dots"></div>
  </div>
</div>
